/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1SsoimageIdStatusMutationRequest,
  PatchApiV1SsoimageIdStatusMutationResponse,
  PatchApiV1SsoimageIdStatusPathParams,
  PatchApiV1SsoimageIdStatus400,
  PatchApiV1SsoimageIdStatus401,
  PatchApiV1SsoimageIdStatus500,
} from "../../types/SSOImageController/PatchApiV1SsoimageIdStatus.ts";

function getPatchApiV1SsoimageIdStatusUrl(
  id: PatchApiV1SsoimageIdStatusPathParams["id"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/ssoimage/${id}/status` as const,
  };
  return res;
}

/**
 * @description Atualiza o ESSOImageStatus de uma SSOImage pelo Id. **(Requer Authorization para autenticação)**
 * @summary Atualizar status de imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/status}
 */
export async function patchApiV1SsoimageIdStatus(
  id: PatchApiV1SsoimageIdStatusPathParams["id"],
  data: PatchApiV1SsoimageIdStatusMutationRequest,
  config: Partial<RequestConfig<PatchApiV1SsoimageIdStatusMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiV1SsoimageIdStatusMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1SsoimageIdStatus400
      | PatchApiV1SsoimageIdStatus401
      | PatchApiV1SsoimageIdStatus500
    >,
    PatchApiV1SsoimageIdStatusMutationRequest
  >({
    method: "PATCH",
    url: getPatchApiV1SsoimageIdStatusUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
